import React, { useState, useEffect } from "react";
import axios from "axios";
import Card from "@mui/joy/Card";
import Box from "@mui/joy/Box";
import CardContent from "@mui/joy/CardContent";
import CardOverflow from "@mui/joy/CardOverflow";
import AspectRatio from "@mui/joy/AspectRatio";
import Typography from "@mui/joy/Typography";
import Divider from "@mui/joy/Divider";
import Avatar from "@mui/joy/Avatar";
import Grid from "@mui/joy/Grid";
import Button from "@mui/joy/Button";
import ImageIcon from "@mui/icons-material/Image";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import FormHelperText from "@mui/joy/FormHelperText";
import Input from "@mui/joy/Input";
import Textarea from "@mui/joy/Textarea";
import Autocomplete from "@mui/joy/Autocomplete";
import GaleriaImagenes from "./galeria"; // Importando la galería
import Alert from "@mui/joy/Alert";
import { useNavigate } from "react-router-dom";
import HikingIcon from "@mui/icons-material/Hiking";
import ErrorIcon from "@mui/icons-material/Error";
import { getCities, getCountries } from "countries-cities";
import imageCompression from "browser-image-compression";
import heic2any from "heic2any";
import Switch from "@mui/joy/Switch";
import EmpresasGuiasTurismo from "./empresas-guias-turismo";

export default function Perfil() {
  let [actividades, setActividades] = React.useState([]);
  let [opcionesinterespersonal, setOpcionesinterespersonal] = React.useState(
    []
  );
  let [botonestado, setBotonestado] = React.useState(false);
  let [cargaformdata, setCargaformdata] = React.useState(false);

  let [formdata, setFormdata] = React.useState({
    id: "",
    nombre: "",
    fecha_de_nacimiento: "",
    genero: "",
    ciudad: "",
    pais: "",
    foto_de_perfil: "",
    galeria: [],
    interesespersonales: "",
    actividades: [],
    descripcion_perfil: "",
    imagenes_eliminadas: [],
    ocultar_perfil: "",
  });

  let [avatar, setAvatar] = React.useState("");
  let [contenidoAlerta, setcontenidoAlerta] = React.useState({
    color: "",
    startDecorator: "",
    contenido: "",
    estado: false,
  });
  let [paises, setPaises] = React.useState(getCountries());
  let [ciudades, setCiudades] = React.useState(getCities(formdata.pais));
  let navigate = useNavigate();
  let url = process.env.REACT_APP_FRONTEND_URL;
  let linkimagen = process.env.REACT_APP_DOSPACES;

  /* Enviar Información al Backend */

  const enviarFormulario = async (formdata) => {
    try {
      const formData = new FormData();

      // Agregar los campos normales al FormData
      formData.append("id", formdata.id);
      formData.append("nombre", formdata.nombre);
      formData.append("fecha_de_nacimiento", formdata.fecha_de_nacimiento);
      formData.append("genero", formdata.genero);
      formData.append("ciudad", formdata.ciudad);
      formData.append("pais", formdata.pais);
      formData.append("descripcion_perfil", formdata.descripcion_perfil);
      formData.append("ocultar_perfil", formdata.ocultar_perfil);

      // Convertir arrays a JSON string si no son archivos
      formData.append("interesespersonales", formdata.interesespersonales);
      formData.append("actividades", JSON.stringify(formdata.actividades));
      formData.append(
        "imagenes_eliminadas",
        JSON.stringify(formdata.imagenes_eliminadas)
      );

      formData.append("foto_de_perfil", formdata.foto_de_perfil);

      // Agregar cada archivo de la galería
      if (formdata.galeria.length > 0) {
        formdata.galeria.forEach((archivo, index) => {
          formData.append(`galeria`, archivo);
        });
      }

      // Enviar al backend
      const response = await axios.post(
        `${url}/api/actualizar-cuenta`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Formulario enviado exitosamente", response.data);

      setcontenidoAlerta({
        color: "success",
        startDecorator: <HikingIcon />,
        contenido: "Información lista, ahora a la aventura",
        estado: true,
      });

      setTimeout(() => {
        setcontenidoAlerta({ estado: false });
        window.location.href = "/cuenta";
      }, 3000);
    } catch (error) {
      console.error("Error al enviar el formulario", error);
      setcontenidoAlerta({
        color: "danger",
        startDecorator: <ErrorIcon />,
        contenido: "No pudimos guardar los cambios. Vuelve a intentarlo.",
        estado: true,
      });

      setTimeout(() => {
        setcontenidoAlerta({ estado: false });
        window.location.href = "/cuenta";
      }, 3000);
    }
  };

  /* Enviar Información al Backend */

  /* PROCESAR IMAGENES GALERIA, HECHO POR CHATGPT */

  const handleGaleriaChange = (nuevaGaleria) => {
    setFormdata((prevData) => ({
      ...prevData,
      galeria: nuevaGaleria, // Actualiza solo el campo "galeria"
    }));
  };
  /* PROCESAR IMAGENES GALERIA, HECHO POR CHATGPT */

  /* PROCESAR IMAGEN HECHO POR CHATGPT */

  const handleButtonClick = () => {
    document.getElementById("fileInput").click();
  };

  /* PROCESAR IMAGEN HECHO POR CHATGPT */

  /* Calcula la edad del usuario */

  const fechaNacimiento = new Date(formdata.fecha_de_nacimiento);
  const edad =
    new Date().getFullYear() -
    fechaNacimiento.getFullYear() -
    (new Date().setFullYear(new Date().getFullYear()) <
    fechaNacimiento.setFullYear(fechaNacimiento.getFullYear())
      ? 1
      : 0);
  /* Calcula la edad del usuario */

  /* Informacion de la cuenta */

  React.useEffect(() => {
    let getinformacionPersonal = async () => {
      try {
        /* OBTENER BEARER TOKEN */
        let token = localStorage.getItem("token");

        /* OBTENER BEARER TOKEN */

        let getinformacion = await axios.get(`${url}/api/cuenta`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setFormdata((valoresanteriores) => ({
          ...valoresanteriores,
          ...getinformacion.data[0],
        }));
        setAvatar(
          `${linkimagen}/uploads/` + getinformacion.data[0].foto_de_perfil
        );

        setCiudades(getCities(getinformacion.data[0].pais));
        setCargaformdata(true);
      } catch (err) {
        if (err.response.status === 403) {
          navigate("/iniciar-sesion");
        }
      }
    };
    getinformacionPersonal();
  }, []);

  /* Informacion de la cuenta */

  /* Recoger actividades */
  React.useState(() => {
    try {
      /* OBTENER BEARER TOKEN */
      let token = localStorage.getItem("token");

      /* OBTENER BEARER TOKEN */

      let getactividades = async () => {
        let actividadesrecoger = await axios.get(`${url}/api/categorias`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        let actividadesnombres = actividadesrecoger.data.map(
          (x) => x.nombre_categoria
        );
        setActividades(actividadesnombres);
      };
      getactividades();
    } catch (err) {
      console.log("Error en recoger actividades");
    }
  }, []);

  /* Recoger actividades */

  /* Recoger intereses personales */

  React.useState(() => {
    let getinteresespersonales = async () => {
      let infoInteresesPersonales = await axios.get(
        `${url}/api/intereses-personales`
      );
      let interespersonal = infoInteresesPersonales.data.map(
        (x) => x.nombre_interes_personal
      );
      setOpcionesinterespersonal(interespersonal);
    };
    getinteresespersonales();
  }, []);

  /* Recoger intereses personales */

  let informacionPersonal = () => {
    return (
      <Card sx={{ width: "100%" }}>
        <CardOverflow sx={{ display: "flex", marginTop: "0.5rem", gap: 1 }}>
          <Typography level="title-md">Información personal</Typography>
          <Typography level="body-sm">
            Personaliza cómo se mostrará la información de tu perfil a las
            redes.
          </Typography>
        </CardOverflow>
        <Box>
          <Divider />
        </Box>
        <CardContent sx={{ margin: "2rem" }}>
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                alignContent: "center",
                flexDirection: "column",
              }}
            >
              <Avatar
                src={avatar}
                alt="Foto de perfil"
                sx={{ width: 150, height: 150 }}
              />

              <Button
                variant="outlined"
                color="neutral"
                sx={{ marginTop: "1rem", width: "100%" }}
                startDecorator={<ImageIcon />}
                onClick={handleButtonClick}
              >
                Cambiar Imagen
              </Button>
              <input
                type="file"
                id="fileInput"
                style={{ display: "none" }}
                accept="image/*"
                onChange={async (event) => {
                  const file = event.target.files[0];
                  if (file) {
                    let opciones = {
                      maxSizeMB: 1, // Máximo 1MB
                      maxWidthOrHeight: 1024, // Redimensionar si es necesario
                      useWebWorker: true,
                    };
                    try {
                      let imagenRecibida = file;

                      /* EN CASO DE ARCHIVOS .HEIC */

                      if (
                        imagenRecibida.type === "image/heic" ||
                        imagenRecibida.type === "image/heif"
                      ) {
                        let blob = await heic2any({
                          blob: file,
                          toType: "image/jpeg",
                          quality: 0.8,
                        });
                        imagenRecibida = new File(
                          [blob],
                          "imagen_convertida.jpg",
                          {
                            type: "image/jpeg",
                          }
                        );
                      }

                      /* EN CASO DE ARCHIVOS .HEIC */

                      let imagenComprimida = await imageCompression(
                        imagenRecibida,
                        opciones
                      );

                      // Convertir a JPG si el formato es diferente
                      const imagenBlob = await imageCompression(
                        imagenComprimida,
                        {
                          fileType: "image/jpeg",
                        }
                      );

                      // Crear un nuevo archivo JPG
                      const imagenJPG = new File([imagenBlob], "imagen.jpg", {
                        type: "image/jpeg",
                      });

                      setFormdata((prev) => ({
                        ...prev,
                        foto_de_perfil: imagenJPG, // Guardar el archivo real
                      }));
                      setAvatar(URL.createObjectURL(imagenJPG));
                    } catch (err) {
                      console.log(
                        "Tenemos un error al subir la foto de perfil " + err
                      );
                    }
                  }
                }}
              />
              <Box sx={{ width: "100%", marginTop: 2 }}>
                <Typography level="body-sm" sx={{ textAlign: "left" }}>
                  Opciones Avanzadas
                </Typography>
                <Grid item container spacing={2} sx={{ marginTop: 1 }}>
                  <Grid>
                    <Switch
                      checked={formdata.ocultar_perfil}
                      size="md"
                      sx={{
                        "--Switch-trackBackground": "#ccc", // fondo cuando está OFF
                        "--Switch-thumbColor": "#fff", // thumb OFF
                        "&:hover": {
                          "--Switch-trackBackground": "#bbb", // hover OFF
                        },
                        "&.Mui-checked": {
                          "--Switch-trackBackground": "#123524", // fondo ON
                          "--Switch-thumbColor": "#fff", // thumb ON
                        },
                        "&.Mui-checked:hover": {
                          "--Switch-trackBackground": "#0f2a1d", // hover ON
                        },
                      }}
                      startDecorator={
                        <Typography level="body-sm">Ocultar perfil</Typography>
                      }
                      onChange={(event) => {
                        if (formdata.ocultar_perfil) {
                          setFormdata((valoresanteriores) => ({
                            ...valoresanteriores,
                            ocultar_perfil: false,
                          }));
                          console.log(formdata);
                        } else {
                          setFormdata((valoresanteriores) => ({
                            ...valoresanteriores,
                            ocultar_perfil: true,
                          }));
                          console.log(formdata);
                        }
                      }}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={8}>
              <Box>
                <Grid container spacing={2} sx={{ display: "flex" }}>
                  <Grid
                    item
                    xs={6}
                    sx={{ display: "flex", flexDirection: "column" }}
                  >
                    <FormLabel>Nombre</FormLabel>
                    <Input value={formdata.nombre} disabled />
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sx={{ display: "flex", flexDirection: "column" }}
                  >
                    <FormLabel>Edad</FormLabel>
                    <Input value={edad + " años"} disabled />
                  </Grid>
                </Grid>
                <Grid
                  container
                  spacing={2}
                  sx={{ display: "flex", marginTop: "1rem" }}
                >
                  <Grid
                    item
                    xs={6}
                    sx={{ display: "flex", flexDirection: "column" }}
                  >
                    <FormLabel>Pais</FormLabel>
                    <Autocomplete
                      options={paises}
                      value={formdata.pais}
                      disableClearable
                      onChange={(event, value) => {
                        console.log(formdata);
                        setCiudades(getCities(value));
                        setFormdata((valoresanteriores) => ({
                          ...valoresanteriores,
                          pais: value,
                          ciudad: "",
                        }));
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sx={{ display: "flex", flexDirection: "column" }}
                  >
                    <FormLabel>Ciudad</FormLabel>
                    <Autocomplete
                      value={formdata.ciudad}
                      options={ciudades}
                      disableClearable
                      onChange={(event, value) => {
                        console.log(formdata);

                        setFormdata((valoresanteriores) => ({
                          ...valoresanteriores,
                          ciudad: value,
                        }));
                      }}
                    />
                  </Grid>
                </Grid>
                <FormHelperText
                  sx={{
                    width: "inherit",
                    maxWidth: "500px",
                    marginTop: "0.5rem",
                  }}
                >
                  Cambiar de País y Ciudad afectará tu feed, es decir, conocerás
                  las personas del país que selecciones
                </FormHelperText>
                <Grid container spacing={2} sx={{ marginTop: "1rem" }}>
                  <Grid
                    item
                    xs={6}
                    sx={{ display: "flex", flexDirection: "column" }}
                  >
                    <FormLabel>Genero</FormLabel>
                    <Input value={formdata.genero} disabled />
                  </Grid>
                </Grid>
                <FormControl>
                  <FormLabel sx={{ marginTop: "1rem", marginBottom: "1rem" }}>
                    Descripción del Perfil
                  </FormLabel>
                  <Textarea
                    variant="outlined"
                    minRows={4}
                    value={formdata.descripcion_perfil}
                    onChange={(event, value) => {
                      console.log(formdata);

                      setFormdata((valoresanteriores) => ({
                        ...valoresanteriores,
                        descripcion_perfil: event.target.value.slice(0, 100),
                      }));
                    }}
                  ></Textarea>
                  <FormHelperText>Cambia tu Descripción</FormHelperText>
                </FormControl>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  };

  let preferenciasPersonales = () => {
    return (
      <Card sx={{ width: "100%", marginTop: "2rem" }}>
        <CardOverflow sx={{ display: "flex", marginTop: "0.5rem", gap: 1 }}>
          <Typography level="title-md">Preferencias personales</Typography>
        </CardOverflow>
        <Box>
          <Divider />
        </Box>
        <CardContent>
          <FormControl>
            <FormLabel>Actividades</FormLabel>
            <Autocomplete
              multiple
              options={actividades}
              value={formdata.actividades}
              onChange={(event, value) => {
                setFormdata((valoranterior) => ({
                  ...valoranterior,
                  actividades: value.slice(0, 3),
                }));
              }}
            />
            <FormHelperText>
              Estas son las actividades que realizas o te interesan
            </FormHelperText>

            <FormLabel sx={{ marginTop: "1rem" }}>¿Qué Busco?</FormLabel>
            <Autocomplete
              options={opcionesinterespersonal}
              value={formdata.interesespersonales}
              onChange={(event, value) => {
                setFormdata((valoranterior) => ({
                  ...valoranterior,
                  interesespersonales: value,
                }));
              }}
            />
          </FormControl>
        </CardContent>
        <CardContent>
          <Box
            sx={{
              display: "flex",
              marginTop: "2rem",
              justifyContent: "center",
            }}
          >
            <Button
              loading={botonestado}
              variant="outlined"
              color="neutral"
              onClick={() => {
                console.log(formdata);
                setBotonestado(true);
                enviarFormulario(formdata);
              }}
            >
              Actualizar Perfil
            </Button>
          </Box>
        </CardContent>
      </Card>
    );
  };

  let subirGaleria = () => {
    return (
      <Box>
        <Card sx={{ width: "100%", marginTop: "2rem" }}>
          <GaleriaImagenes
            imagenes={formdata.galeria} // Pasa las imágenes actuales desde formdata
            onChange={handleGaleriaChange} // Pasa la función para actualizar la galería
            setFormdata={setFormdata}
          />
        </Card>
      </Box>
    );
  };

  /* POPUP */

  let popup = () => {
    return (
      <Alert
        variant="soft"
        className="notificacion"
        color={contenidoAlerta.color}
        startDecorator={contenidoAlerta.startDecorator}
      >
        {contenidoAlerta.contenido}
      </Alert>
    );
  };

  /* POPUP */

  /* CAMBIAR CUENTA A NEGOCIO O GUÍA DE TURISMO */

  let upgradeCuenta = () => {
    return (
      <Box>
        <Card sx={{ width: "100%", marginTop: "2rem", paddingBottom: 5 }}>
          <CardOverflow sx={{ display: "flex", marginTop: "0.5rem", gap: 1 }}>
            <Typography level="title-md">
              Empresas y Guías de turísmo
            </Typography>
          </CardOverflow>
          <CardContent>
            <Box sx={{ maxWidth: "60vw", gap: 5, display: "grid" }}>
              <FormHelperText>
                Si deseas ofrecer aventuras, tours o experiencias guiadas,
                puedes solicitar una cuenta de empresa o guía de turismo.
                Nuestro equipo revisará tu solicitud antes de su activación.
              </FormHelperText>
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                }}
              >
                <EmpresasGuiasTurismo />
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Box>
    );
  };

  /* CAMBIAR CUENTA A NEGOCIO O GUÍA DE TURISMO */

  return (
    <Box
      sx={{
        display: "flex",
        alignContent: "center",
        alignItems: "center",
        justifyContent: "center",
        width: "100vw",
        minHeight: "100vh", // Cambiado para permitir que el contenido crezca
        flexDirection: "column",
        overflowY: "auto", // Habilitar desplazamiento vertical
        padding: "2rem", // Opcional: agregar padding para evitar que el contenido toque los bordes
        boxSizing: "border-box", // Asegurar que el padding no afecte las dimensiones
      }}
    >
      <Grid container spacing={1}>
        <Grid item md={12} xs={12}>
          {contenidoAlerta.estado ? popup() : null}
          {cargaformdata ? informacionPersonal() : null}
          {cargaformdata ? subirGaleria() : null}
          {cargaformdata ? preferenciasPersonales() : null}
        </Grid>
      </Grid>
    </Box>
  );
}
